import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "streaming-sections" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "section-content"
}

import { ref, type PropType } from 'vue';
import MarkDownComponent from '@/components/common/mark-down/MarkDownComponent.vue';
import ConversationActions from '@/components/common/conversation-actions/ConversationActions.vue';
import SectionTitle from '@/components/common/section-title/sectionTitle.vue';
import { SourceDTO } from '@/dto/QuestionResponseDTO';
import { useI18n } from 'vue-i18n';
import { useToasterStore } from '@/stores/useToasterStore';
import { OfficeUtils } from '@/utils/office.utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'CollapsibleSections',
  props: {
  showSections: { type: Boolean, default: false },
  orderedSections: { type: Array as PropType<string[]> },
  sectionResponses: {
    type: Object as PropType<Record<string, string>>,
    required: true
  },
  sectionSources: {
    type: Object as PropType<Record<string, SourceDTO[]>>,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const toaster = useToasterStore();
const openSection = ref<string | null>(null);

function toggleSection(section: string) {
  openSection.value = openSection.value === section ? null : section;
}

async function onSectionIconClick(
  action: 'copy' | 'insert',
  section: string
): Promise<void> {
  const text = props.sectionResponses[section];
  if (!text) return;
  try {
    if (action === 'copy') {
      await OfficeUtils.copyTextToClipboard(text);
      toaster.success({ title: t('actions.toast.text_copied') });
    } else if (action === 'insert') {
      await OfficeUtils.insertTextToDocument(text);
      toaster.success({ title: t('actions.toast.text_inserted') });
    }
  } catch {
    toaster.error({
      title:
        action === 'copy'
          ? t('actions.toast.text_copied.error')
          : t('actions.toast.text_inserted.error')
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderedSections, (section) => {
      return (_openBlock(), _createElementBlock("div", {
        key: section,
        class: "section-chunk"
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["section-title", { active: openSection.value === section }]),
          onClick: ($event: any) => (toggleSection(section))
        }, [
          _createVNode(SectionTitle, { section: section }, null, 8, ["section"]),
          _createElementVNode("span", {
            class: _normalizeClass(["arrow", { open: openSection.value === section }])
          }, "▼", 2)
        ], 10, _hoisted_2),
        (openSection.value === section)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(MarkDownComponent, {
                message: {
            text: __props.sectionResponses[section],
            isBot: true,
            sources: __props.sectionSources[section] || []
          }
              }, null, 8, ["message"]),
              _createVNode(ConversationActions, {
                onAction: 
            (action) => onSectionIconClick(action, section)
          
              }, null, 8, ["onAction"])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})